import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { format } from 'date-fns'

import { sosVariables } from '../../../../../../../components/SosSubForm/types'
import { CollapseContent } from '../../../../../../../components/Collapse/CollapseContent'
import { RouteColumn, RouteRow } from '../../../../../../../components/layout'
import { SelectInput, TextInput } from '../../../../../../../components/layout/form/input'
import { FinishedDateTimeInput } from '../../../../../../../components/layout/form/input/DateTimeInput'
import { Time } from '../../../../../../../types/time'
import { useSosCauseOptions } from '../../../../../../../util/useSosCauseOptions'
import { Modal } from '../../../../../../../components/Modal'
import { FinishedAtBreakdownLocationProps } from './FinishedForm'
import { SosProps } from './ArrivedForm'
import { routeSubformMessages } from '../../messages'

export const FinishedAtBreakdownLocationFormSos: React.FunctionComponent<FinishedAtBreakdownLocationProps & SosProps> = ({
  setValue,
  action,
  setDateField,
  getValue,
  autoliittoFields,
}) => {
  const intl = useIntl()
  const [edit, setEdit] = useState<boolean>(action === 'edit-finished')
  const [showModal, setShowModal] = useState(false)
  const [warned, setWarned] = useState(() => {
    if (autoliittoFields.hasFinishRouteInfo) return false
    return true
  })

  const deliverable = getValue('sosServiceOrder.deliverable')
  const { causeOptions, onDeliverableChange } = useSosCauseOptions(deliverable, setValue)

  const causeIsRequired = (deliverable !== 'Towage' && deliverable !== "Transport")
  const deliverables = sosVariables.deliverable

  const handleOnDeliverableChange = (deliverable: string | number | undefined): void => {
    if (!warned && (deliverable !== 'Towage' && deliverable !== 'Transport')) {
      setWarned(true)
      setShowModal(true)
    }
    setValue('sosServiceOrder.deliverable', deliverable)
    onDeliverableChange(deliverable)
  }

  useEffect(() => {
    if (action === 'edit-finished') {
      if (!edit) setEdit(true)
    } else {
      if (edit) setEdit(false)
    }
  }, [edit, action, setEdit])

  return (
    <CollapseContent>
      {showModal && (
        <Modal
          label={intl.formatMessage(routeSubformMessages.attention)}
          closeLabel={intl.formatMessage(routeSubformMessages.cancelModal)}
          disableCloseOnConfirm
          message={intl.formatMessage(routeSubformMessages.nonTowingServiceWarningMessage)}
          onConfirm={() => {
            setShowModal(false)
          }}
          close={() => {
            setShowModal(false)
            setValue('sosServiceOrder.deliverable', 'Towage')
          }}
        />
      )}
      <RouteRow columns={`1fr 1fr 1fr`}>
        <RouteColumn>
          <SelectInput
            label={intl.formatMessage(routeSubformMessages.action)}
            name="sosServiceOrder.deliverable"
            options={deliverables}
            disabled={!edit}
            onChange={handleOnDeliverableChange}
            required
          />
        </RouteColumn>
        <RouteColumn>
          <SelectInput
            label={intl.formatMessage(routeSubformMessages.fault)}
            name="sosServiceOrder.cause"
            options={causeOptions}
            disabled={!edit && autoliittoFields.disableTowingReason}
            required={causeIsRequired}
          />
        </RouteColumn>
        <RouteColumn>
          <FinishedDateTimeInput
            name="arrivalRoute"
            label={intl.formatMessage(routeSubformMessages.completionTime)}
            customOnChange={() => {
              const value = (format(new Date(), 'HH:mm') as unknown) as Time
              setDateField('arrivalRoute.finishedDate')
              setValue('arrivalRoute.finishedTime', value)
            }}
            required={edit}
            disabled={!edit}
            showCurrentTimeBtn
          />
        </RouteColumn>
      </RouteRow>
      <RouteRow columns={`3fr`}>
        <RouteColumn>
          <TextInput
            name="sosServiceOrder.keyLocation"
            label={intl.formatMessage(routeSubformMessages.keyDropOffLocation)}
            disabled={!edit && autoliittoFields.disableVehicleKeyLocation}
          />
        </RouteColumn>
      </RouteRow>
    </CollapseContent>
  )
}
